/* enfin levé — v57 reskin, stage 2: homepage behaviour.
 *
 * Loaded (deferred) from inside each homepage section, so the file may appear
 * more than once in the document. The guard below makes every extra execution
 * a no-op; the browser serves the duplicates from cache.
 *
 * Responsibilities:
 *   1. hero video playback (muted autoplay, honouring prefers-reduced-motion)
 *   2. sound pill (aria-pressed + label/icon swap)
 *   3. scroll reveal for shop + split halves
 *
 * Nothing here touches Prestige's own DOM or JS.
 */
(function () {
  'use strict';

  if (window.__elHomeV57) return;
  window.__elHomeV57 = true;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------------- */
  /* 1 + 2. Hero video and sound pill                                       */
  /* ---------------------------------------------------------------------- */

  function initHero(root) {
    var heroes = root.querySelectorAll('[data-el-hero]');

    for (var i = 0; i < heroes.length; i++) {
      (function (hero) {
        if (hero.__elInit) return;
        hero.__elInit = true;

        var video = hero.querySelector('[data-el-hero-video]');
        var button = hero.querySelector('[data-el-sound]');

        if (video) {
          video.muted = true;
          video.defaultMuted = true;

          if (REDUCED) {
            // No autoplay at all — the poster stays on screen.
            try { video.pause(); } catch (e) {}
            video.removeAttribute('autoplay');
          } else {
            var play = video.play();
            if (play && typeof play.catch === 'function') {
              // Autoplay refused (iOS Low Power Mode, data saver, …) — the
              // poster remains visible, which is the intended fallback.
              play.catch(function () {});
            }
          }
        }

        if (!button) return;

        if (!video) {
          button.hidden = true;
          return;
        }

        button.addEventListener('click', function () {
          var wasMuted = video.muted;

          video.muted = !wasMuted;
          button.setAttribute('aria-pressed', wasMuted ? 'true' : 'false');

          if (wasMuted) {
            // Unmuting is a user gesture, so playback is allowed even if the
            // muted autoplay above was refused.
            var p = video.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          }
        });
      })(heroes[i]);
    }
  }

  /* ---------------------------------------------------------------------- */
  /* 3. Reveal on scroll                                                     */
  /* ---------------------------------------------------------------------- */

  var observer = null;

  function reveal(el) {
    el.classList.add('is-in');
  }

  function initReveal(root) {
    var targets = root.querySelectorAll('.ElReveal:not(.is-in)');
    var i;

    if (REDUCED || !('IntersectionObserver' in window)) {
      for (i = 0; i < targets.length; i++) reveal(targets[i]);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.1 });
    }

    for (i = 0; i < targets.length; i++) observer.observe(targets[i]);
  }

  /* ---------------------------------------------------------------------- */

  function init(root) {
    var scope = root || document;
    initHero(scope);
    initReveal(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Theme editor: sections are re-rendered without a page reload.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();
